import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Hero from "components/hero/TwoColumnWithVideo.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import Features from "components/features/ThreeColWithSideImage.js";
import SingleCol from "components/faqs/SingleCol";

const HighlightedText = tw.span`text-primary-500`;

export default () => {
  return (
    <AnimationRevealPage>
      <Hero />
      <SingleCol />

      <Features
        heading={
          <>
            Distress <HighlightedText>Protocol</HighlightedText>
          </>
        }
      />
      <Footer />
    </AnimationRevealPage>
  );
};
